export type Contact = {
  name: string;
  image?: string;
  imageBrands?: boolean;
  imageUrl?: string;
  link?: string;
};

export type Informations = {
  name: string;
  poste: string[];
  experience: string;
  disponible: string;
  contact: Contact[];
};

export type SkillItem = {
  level: "REGULAR" | "SOMETIMES" | "OLD";
  items: string[];
};

export type Skill = {
  type?: string;
  break?: boolean;
  items?: SkillItem[];
};

export type Reference = {
  name: string;
  title: string;
  startMonth?: string;
  startYear?: string;
  endMonth?: string;
  endYear?: string;
  skills?: string[];
  context?: string;
  descriptions?: string[];
  subreferences?: Reference[];
};

export type Certificate = {
  name: string;
  image: string;
  month: string;
  year: string;
  state: string;
};

export type Interest = {
  name: string;
  picture: string;
  pictureUrl?: string;
  cssBackgroundClass: string;
};

export type Resume = {
  skills: Skill[];
  certificates: Certificate[];
  references: Reference[];
  projects: Reference[];
  interests: Interest[];
  basics: Informations;
};

export type ProfileType =
  | "all"
  | "architect"
  | "fullstack"
  | "devops"
  | "gamedev";

export const PROFILE_LABELS: Record<ProfileType, string> = {
  all: "Tous",
  architect: "Architecte Applicatif",
  fullstack: "Développeur Fullstack",
  devops: "DevOps / Cloud",
  gamedev: "Game Designer",
};

export const PROFILE_SKILLS: Record<Exclude<ProfileType, "all">, string[]> = {
  architect: [
    "Architecture",
    "Micro Services",
    "Event Driven",
    "REST",
    "Domain Driven",
    "SOAP",
    "Java",
    "Spring",
    "Spring Boot",
    "Liquibase",
    "Sonar",
    "Ecriture de DAG / DAT",
    "Diagramme de flux",
    "Diagramme de séquence",
    "Etudes d'impacts",
    "Avant-vente / AO",
    "Présentation client",
    "Audit",
    "Gestion d'équipe",
    "Formation",
    "Planification",
    "Maven",
    "Hibernate",
    "SQL",
    "Postgres",
    "Jira",
    "Confluence",
    "Architecture IA",
  ],
  fullstack: [
    "Java",
    "Spring",
    "Spring Boot",
    "Spring Security",
    "React",
    "Angular",
    "TypeScript",
    "JavaScript",
    "HTML / CSS",
    "Postgres",
    "MongoDB",
    "SQL",
    "Hibernate",
    "Maven",
    "NPM",
    "Webpack",
    "Mockito",
    "Jest",
    "Quarkus",
    "Quarkus Native",
    "Python",
    "REST",
    "Micro Services",
    "IntelliJ",
  ],
  devops: [
    "Docker",
    "Kubernetes",
    "Ansible",
    "Jenkins",
    "Git",
    "Gitlab",
    "Azure DevOps",
    "Grafana",
    "Linux",
    "Bash",
    "SSH",
    "Apache Kafka",
    "RabbitMQ",
    "ActiveMQ",
    "Rancher",
    "Cloud Privé",
    "Cloud",
    "Sonar",
    "Liquibase",
    "NGinx",
    "Apache VHost",
    "Apache Tomcat",
    "Proxmox",
    "PfSense",
    "VMWare ESXI",
    "VirtualBox",
  ],
  gamedev: [
    "Unity",
    "Unreal Engine",
    "C#",
    "C++",
    "Swift / UI",
    "IOS",
    "Xcode",
    "App Store Connect",
    "CloudKit",
    "Jeux Video",
  ],
};
